<template>
    <div>
        <template class="table-head" >
            <el-table :data="tableDataLists" border height="460" ref="dragTable" v-loading="isLoading">
                <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" v-for="(item, index) in tableDataItems"
                    :key="index" >
                    <template slot-scope="scope">
                        <span v-if="item.status === 'redStyle' && scope.row.feeTaskType === '30'" class="font-red">
                            {{`(` + scope.row[item.prop] + `)`}}
                        </span>
                        <span v-else>
                            {{scope.row[item.prop]}}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        tableDataLists: {
            type: Array
        },
        tableDataItems: {
            type: Array
        },
        billTableDataItems: {
            type: Array
        }
    },
    data() {
        return {
            isLoading: false
        };
    }
};
</script>

<style lang="less">

</style>
